import { configureStore } from "@reduxjs/toolkit";
import {
  persistStore,
  persistReducer,
  FLUSH,
  REHYDRATE,
  PAUSE,
  PERSIST,
  PURGE,
  REGISTER,
} from "redux-persist";
import storage from "redux-persist/lib/storage";
import { authApi } from "redux/services/auth";
import { membershipApi } from "redux/services/membership";
import { dataLoaderApi } from "redux/services/dataLoader";
import { externalApi } from "redux/services/external";
import { documentApi } from "redux/services/documentRepository";
import { approvalProcessorApi } from "redux/services/approvalProcessor";
import { approvalRuleApi } from "redux/services/approvalRule";
import { auditApi } from "redux/services/auditRecord";
import {
  indetityApi,
  indetityApiAppToken,
  setPasswordApiAppToken,
} from "redux/services/identity";
import rootReducer from "redux/rootReducer";
import { errorListener } from "redux/slices/errorSlice";

const persistConfig = {
  key: "root",
  version: 1,
  storage,
  whitelist: ["auth"],
};

const persistedReducer = persistReducer(persistConfig, rootReducer);

export const store = configureStore({
  reducer: persistedReducer,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: {
        ignoredActions: [FLUSH, REHYDRATE, PAUSE, PERSIST, PURGE, REGISTER],
      },
    })
      .prepend(errorListener.middleware)
      .concat(
        authApi.middleware,
        membershipApi.middleware,
        dataLoaderApi.middleware,
        externalApi.middleware,
        documentApi.middleware,
        approvalProcessorApi.middleware,
        approvalRuleApi.middleware,
        auditApi.middleware,
        indetityApi.middleware,
        indetityApiAppToken.middleware,
        setPasswordApiAppToken.middleware
      ),
});

export const setupStore = (preloadedState?: Partial<RootState>) => {
  return configureStore({
    reducer: persistedReducer,
    middleware: (getDefaultMiddleware) =>
      getDefaultMiddleware({
        serializableCheck: {
          ignoredActions: [FLUSH, REHYDRATE, PAUSE, PERSIST, PURGE, REGISTER],
        },
      })
        .prepend(errorListener.middleware)
        .concat(
          authApi.middleware,
          membershipApi.middleware,
          dataLoaderApi.middleware,
          approvalProcessorApi.middleware,
          externalApi.middleware,
          documentApi.middleware,
          auditApi.middleware,
          approvalRuleApi.middleware,
          indetityApi.middleware,
          indetityApiAppToken.middleware,
          setPasswordApiAppToken.middleware,
          auditApi.middleware
        ),
    preloadedState,
  });
};

export const persistor = persistStore(store);

export type RootState = ReturnType<typeof store.getState>;
export type AppStore = ReturnType<typeof setupStore>;
export type AppDispatch = typeof store.dispatch;
